import { gql } from '@apollo/client';
import { itemsFragment } from '../fragments/items';
import { graphql } from '../../graphql';

export const agenciesQuery = graphql(`
  query Agencies {
    agencies(sort: RANDOM) {
      id
      name
      logoUrl
      description
      itemsCount
      path
    }
  }
`);

export const getSelectedAgencyQuery = graphql(`
  query SelectedAgency($slug: String!) {
    agency(slug: $slug) {
      id
      name
      description
      viewsCount
      contactAddress
      schedule
      phonesMasked
      latitude
      longitude
      logoUrl
      coverUrl
      itemsCount
      path
      itemCategories {
        id
        pluralName
      }
    }
    categories {
      id
      title
      children {
        id
        title
      }
    }
  }
`);

export const filteredAgenciesQuery = gql`
  query FilteredAgencies($first: Int, $filter: ItemFilter, $cursor: String) {
    itemsConnection(first: $first, after: $cursor, filter: $filter) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...itemFields
        }
      }
    }
  }
  ${itemsFragment}
`;

export const getSelectedAgencyShortDataQuery = graphql(`
  query SelectedAgencyShortData($id: ID!) {
    agency(id: $id) {
      id
      itemCategories {
        id
        pluralName
      }
    }
    categories {
      id
      title
      children {
        id
        title
      }
    }
  }
`);
